import moment from "moment"

// Returns a single row for an agent in the leaderboard
export default function AgentRow({ details, leaderboardID, bookings }) {
	// Return early if this agent is not part of the selected leaderboard
	if (leaderboardID !== details?.leaderboard_id) return null

	// Otherwise pull some details
	const { first_name, last_name, targets } = details

	// Pull the targets for this agent
	const dailyTarget = targets?.daily || 0
	const weeklyTarget = targets?.weekly || 0
	const monthlyTarget = targets?.monthly || 0

	// Calculate the totals for this agent
	const todaySales = bookings.filter((booking) => booking.booked?.seconds > moment().startOf("day").unix()).reduce((acc, booking) => acc + (booking.margins?.customer_price || 0), 0)
	const todayMargin = bookings.filter((booking) => booking.booked?.seconds > moment().startOf("day").unix()).reduce((acc, booking) => acc + (booking.margins?.profit || 0), 0)
	const weekSales = bookings.filter((booking) => booking.booked?.seconds > moment().startOf("week").unix()).reduce((acc, booking) => acc + (booking.margins?.customer_price || 0), 0)
	const weekMargin = bookings.filter((booking) => booking.booked?.seconds > moment().startOf("week").unix()).reduce((acc, booking) => acc + (booking.margins?.profit || 0), 0)
	const monthSales = bookings.filter((booking) => booking.booked?.seconds > moment().startOf("month").unix()).reduce((acc, booking) => acc + (booking.margins?.customer_price || 0), 0)
	const monthMargin = bookings.filter((booking) => booking.booked?.seconds > moment().startOf("month").unix()).reduce((acc, booking) => acc + (booking.margins?.profit || 0), 0)

	// Calculate the margin percentages
	const dailyMarginPercentage = Number.parseInt((todayMargin / dailyTarget) * 100)
	const weeklyMarginPercentage = Number.parseInt((weekMargin / weeklyTarget) * 100)
	const monthlyMarginPercentage = Number.parseInt((monthMargin / monthlyTarget) * 100)

	// Format the totals
	const todaySalesFormatted = todaySales.toLocaleString("en-GB", { style: "currency", currency: "GBP", minimumFractionDigits: 0, maximumFractionDigits: 0 })
	const todayMarginFormatted = todayMargin.toLocaleString("en-GB", { style: "currency", currency: "GBP", minimumFractionDigits: 0, maximumFractionDigits: 0 })
	const weekSalesFormatted = weekSales.toLocaleString("en-GB", { style: "currency", currency: "GBP", minimumFractionDigits: 0, maximumFractionDigits: 0 })
	const weekMarginFormatted = weekMargin.toLocaleString("en-GB", { style: "currency", currency: "GBP", minimumFractionDigits: 0, maximumFractionDigits: 0 })
	const monthSalesFormatted = monthSales.toLocaleString("en-GB", { style: "currency", currency: "GBP", minimumFractionDigits: 0, maximumFractionDigits: 0 })
	const monthMarginFormatted = monthMargin.toLocaleString("en-GB", { style: "currency", currency: "GBP", minimumFractionDigits: 0, maximumFractionDigits: 0 })

	return (
		<tr>
			<td>
				<p>
					{first_name} {last_name}
				</p>
			</td>
			<td>
				<p>{todaySalesFormatted}</p>
			</td>
			<td>
				<p className={[dailyMarginPercentage > 100 ? "is-complete" : ""]}>
					<span>{todayMarginFormatted}</span> {dailyTarget > 0 && <small>({dailyMarginPercentage || 0}%)</small>}
				</p>
			</td>
			<td>
				<p>{weekSalesFormatted}</p>
			</td>
			<td>
				<p className={[weeklyMarginPercentage > 100 ? "is-complete" : ""]}>
					<span>{weekMarginFormatted}</span> {weeklyTarget > 0 && <small>({weeklyMarginPercentage || 0}%)</small>}
				</p>
			</td>
			<td>
				<p>{monthSalesFormatted}</p>
			</td>
			<td>
				<p className={[monthlyMarginPercentage > 100 ? "is-complete" : ""]}>
					<span>{monthMarginFormatted}</span> {monthlyTarget > 0 && <small>({monthlyMarginPercentage || 0}%)</small>}
				</p>
			</td>
		</tr>
	)
}
